import { useEffect, useState } from 'react';

type Props = {
  limit: number;
  resetKey?: string;
};

export const useSearchablePagination = ({ limit, resetKey }: Props) => {
  const [from, setFrom] = useState(0);

  useEffect(() => {
    setFrom(0);
  }, [limit, resetKey]);

  const currentPage = from / limit + 1;

  const handleNext = () => {
    setFrom((prev) => prev + limit);
  };
  const handlePrevious = () => {
    setFrom((prev) => Math.max(0, prev - limit));
  };

  return {
    from,
    currentPage,
    handleNext,
    handlePrevious
  };
};
